import { render, staticRenderFns } from "./agree.vue?vue&type=template&id=53ff1d42&scoped=true&"
import script from "./agree.vue?vue&type=script&lang=js&"
export * from "./agree.vue?vue&type=script&lang=js&"
import style0 from "./agree.vue?vue&type=style&index=0&id=53ff1d42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ff1d42",
  null
  
)

component.options.__file = "agree.vue"
export default component.exports